import React from "react";
import {
    Paper,
    Table as MuiTable,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import {observer} from "mobx-react";
import "./collapsibleTable.scss";

export type TableActionFunction = (model: any) => JSX.Element;

interface CollapsibleTableProps {
    headers: string[];
    subHeaders: string[];
    properties: string[];
    subProperties: string[];
    rows: any[];
    testId: string;
}

function CollapsibleTable(props: CollapsibleTableProps): JSX.Element {
    function renderHeaderDefault(header: string, index?: number, width?: string) {
        return (
            <TableCell key={`header-${index}`} align={"left"} width={width}>
                {header}
            </TableCell>
        );
    }
    const headers = props.headers.concat("");

    return (
        <TableContainer className="collapsible-table" component={Paper}>
            <MuiTable data-testid={props.testId}>
                <TableHead className="collapsible-table-header">
                    <TableRow>
                        {renderHeaderDefault("", undefined, "10px")}
                        {headers.map((header, index) => {
                            return renderHeaderDefault(header, index);
                        })}
                    </TableRow>
                </TableHead>
                <TableBody className="collapsible-table-body">
                    {props.rows}
                </TableBody>
            </MuiTable>
        </TableContainer>
    );
}

export default observer(CollapsibleTable);
